import { render } from "./MainAccountsReceivable.vue?vue&type=template&id=0c795447&scoped=true"
import script from "./MainAccountsReceivable.vue?vue&type=script&lang=js"
export * from "./MainAccountsReceivable.vue?vue&type=script&lang=js"

import "./MainAccountsReceivable.vue?vue&type=style&index=0&id=0c795447&scoped=true&lang=css"

import exportComponent from "D:\\facturacion electronica\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c795447"]])

export default __exports__